import { EnderecoParmDTO } from "./address";
import { BaseFiltroPagDTO } from "./base-dto";

export class AgendamentoVisitaParmDTO {
  id: number;
  idInstituicao: number;
  presencial: boolean;
  data: string;
  horario: string;
  endereco: EnderecoParmDTO;
  idsVisitantes: number[];
  idsContatos: number[];
  objetivo: string;
  observacao: string;
  provisorio: boolean;
}

export class AgendamentoVisitaFiltroDTO extends BaseFiltroPagDTO {
  idsInstituicoes: number[];
  dataIni: string;
  dataFim: string;
  provisorio: boolean;
  urgente: boolean;
  comVisita: boolean;
  idsVisitantes: number[];
  idsContatos: number[];
  participacao: string;
  presencial: boolean;
}